"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRedHatRepositoriesFromExtractedLayers = exports.getRedHatRepositoriesContentAction = void 0;
const stream_utils_1 = require("../../stream-utils");
exports.getRedHatRepositoriesContentAction = {
    actionName: "redhat-content-manifests",
    filePathMatches: isRedHatContentManifest,
    callback: stream_utils_1.streamToJson,
};
function getRedHatRepositoriesFromExtractedLayers(extractedLayers) {
    const repositories = [];
    for (const filePath in extractedLayers) {
        if (isRedHatContentManifest(filePath)) {
            const contentManifest = extractedLayers[filePath]["redhat-content-manifests"];
            if (!contentManifest || !contentManifest.content_sets) {
                continue;
            }
            repositories.push(...contentManifest === null || contentManifest === void 0 ? void 0 : contentManifest.content_sets);
        }
    }
    return [...new Set(repositories)];
}
exports.getRedHatRepositoriesFromExtractedLayers = getRedHatRepositoriesFromExtractedLayers;
function isRedHatContentManifest(filePath) {
    return filePath.startsWith("/root/buildinfo/content_manifests/");
}
//# sourceMappingURL=static.js.map